import { useEffect, useState } from "react";

export default function CampaignDonorsBlock({ campaign }) {
  const [donationsDetails, setDonationsDetails] = useState([]);
  const [sortedUpdates, setSortedUpdates] = useState([]);

  useEffect(() => {
    if (campaign?.donations_details) {
      // Filters for only completed donations
      const filteredDonations = campaign.donations_details.filter(
        (donation) => donation.status === "completed"
      );

      // Sort donations by donation date from latest to oldest
      const sortedDonations = filteredDonations.sort((a, b) => {
        // Ensure both dates are parsed into Date objects
        const dateA = new Date(a.donation_date);
        const dateB = new Date(b.donation_date);

        // Sort in descending order (latest first)
        return dateB - dateA;
      });

      // Set sorted donations
      setDonationsDetails(sortedDonations.slice(0, 4));
    }

    if (campaign?.update_info) {
      // Sort updates by timestampe from most recent to oldest
      const sortedUpdates = [...campaign.update_info].sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);

        return dateB - dateA;
      });

      setSortedUpdates(sortedUpdates);
    }
  }, [campaign]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  return (
    <div className="flex flex-col w-full gap-8 flex-1">
      {/* Updates Box */}
      <div className="border rounded-2xl shadow-lg p-6 w-full flex-1">
        <h1 className="font-bold text-left mb-4 font-poppins text-[24px]">Recent Updates</h1>
        <div className="space-y-4">
          {sortedUpdates && sortedUpdates.length > 0 ? (
            sortedUpdates.map((update, idx) => (
              <div key={idx} className="border-b border-gray-200 py-2">
                {update.content}
              </div>
            ))
          ) : (
            <div className="text-center my-4 text-blue">no updates yet</div>
          )}
        </div>
      </div>

      {/* Recent Contributors Box */}
      <div className="border rounded-2xl shadow-lg p-6 w-full flex-1">
        <h1 className="font-bold text-left my-4 font-poppins text-[24px]">
          Recent Contributors
        </h1>
        {donationsDetails.length > 0 ? (
          donationsDetails.map((donation) => (
            <div
              key={donation.pid}
              className="flex mx-8 justify-between my-4 items-center py-2"
            >
              <div>
                <p className="font-semibold">
                  {donation.donor_first_name} contributed &nbsp;
                  <span className="text-blue font-bold">
                    ${donation.amount.toLocaleString()}
                  </span>
                </p>
              </div>
              <p className="text-sm text-gray-500">
                {formatDate(donation.donation_date)}
              </p>
            </div>
          ))
        ) : (
          <div className="text-center my-4 text-blue">
            no contributors yet
          </div>
        )}
      </div>
    </div>
  );
}
